import { useMemo } from "react";
import { Breakpoints } from "types-for/breakpoints";

/**
 * Check the current media query to determine the device type.
 */
export const useMediaCheck = () => {
    const isMobile = useMemo(() => window.matchMedia(`(max-width: ${Breakpoints.Mobile}px)`).matches, []);
    const isTablet = useMemo(() => window.matchMedia(`(max-width: ${Breakpoints.Tablet}px)`).matches, []);
    const isDesktop = useMemo(() => !isMobile && !isTablet, [isMobile, isTablet]);

    return { isMobile, isTablet, isDesktop };
};
